const ITEMS = [
  "Commerces",
  "Artisans",
  "Avocats & Cabinets",
  "Agents immobiliers",
  "Professions libérales",
  "Indépendants",
];

const Row = ({ hidden }) => (
  <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-2xl font-semibold text-white sm:text-3xl">
          {item}
        </span>
        <span className="text-lg text-gold">◆</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="border-y border-navy/10 bg-navy py-6">
    <div className="overflow-hidden">
      <div className="marquee-track">
        <Row />
        <Row hidden />
      </div>
    </div>
  </section>
);
